import PizzaImage1 from '../images/foodImages/pizza/Pizza_img1.jpg';

const PizzaItems = [
  {
    id: 1,
    name: '蛋黃鮮蝦烤餅',
    price: 280,
    description: '精緻的蛋黃與鮮蝦，讓您每一口都充滿驚喜。',
    image: PizzaImage1,
  },
  {
    id: 2,
    name: '泡菜雞烤餅',
    price: 220,
    description: '外脆內嫩的雞肉和泡菜的酸辣風味，帶來無與倫比的美味。',
    image: PizzaImage1,
  },
  {
    id: 3,
    name: '巧克力香蕉烤餅',
    price: 200,
    description: '甜蜜的巧克力與新鮮香蕉相融合，讓每一口都是滿滿的甜蜜滋味。',
    image: PizzaImage1,
  },
  {
    id: 4,
    name: '墨西哥辣椒德式香腸烤餅',
    price: 220,
    description: '由新鮮的德式香腸與辣椒共同演繹，帶來濃郁的口感，讓您大快朵頤。',
    image: PizzaImage1,
  },
];

export default PizzaItems;
